module.exports = __webpack_public_path__ + "static/media/3ll24.e9e27a37.png";